<div cl>
  <nz-empty nzNotFoundImage="simple" ></nz-empty>
</div>
